import vetting_modal from './vetting_modal.js'
import pages from './pages.js'
import firebase from './firebase.js'

export default {
  app_name: 'Suitup',
  operation_name: 'Suitup',
  display_app_name: 'Suitup',
  stylesheet: '/suitup.css',
  favicon: '/suitup_favicon.png',
  base_api_url: 'https://suitupapi.club/',
  // conv-svc / intake operation slug — routes the readonly chatbot panel to this tenant's API
  intake_operation_slug: 'suitup',
  preview_link: 'https://suitup.website/offer_preview/',
  company_panel_url: 'https://companies.suitup.co.il/',
  seo_single_position_path: 'single_position',
  hr_email: 'hr@suitup.co.il',
  field: 'המשפט',
  recruitement_field: 'השמת עורכי דין',
  discrete_emoji: '🤩',
  icon: '⭐',
  files: {
    is_profile_default_checked: true
  },
  applicant_modal: {
    languages: ['אנגלית']
  },
  applicant_history_company_modal: {
    job_title_options: ['עו"ד', 'מתמחה', 'יועמ"ש']
  },
  vetting_modal,
  pages,
  images: {
    logo_bright: '/suitup_logo_bright.png',
    logo_dark: '/suitup_logo_dark.png'
  },
  links: {
    website_url: 'https://www.suitup.co.il/',
    web_base_url: 'https://suitup.co.il/',
    app_store_url: 'https://apps.apple.com/il/app/suitup-קריירה-משפטית/id1320598994',
    google_play_url: 'https://play.google.com/store/apps/details?id=io.suitup'
  },
  hashtags: 'suitup',
  firebase
}
